import axios from "axios";
import { getBaseUrl } from "./environment-url";
import { refreshAuthToken } from "../hooks/hook";

/** Applied when a request does not set `timeout` in its config (axios merges per-request `timeout` over this). */
const DEFAULT_API_TIMEOUT_MS = 10_000;

const API = axios.create({
  baseURL: getBaseUrl(process.env.REACT_APP_NODE_ENV, "REACT_APP_REST_API_URL"),
  responseType: "json",
  withCredentials: false,
  timeout: DEFAULT_API_TIMEOUT_MS,
});

API.interceptors.request.use((config) => {
  if (config.timeout === undefined) {
    config.timeout = DEFAULT_API_TIMEOUT_MS;
  }

  // Fetch the token from sessionStorage or localStorage
  let token = sessionStorage.getItem("token") || localStorage.getItem("token") || "";

  if (!token) {
    console.warn("No token found in sessionStorage or localStorage");
  }

  // Set the Authorization header
  config.headers["Authorization"] = `Bearer ${token}`;

  return config;
}, (error) => {
  console.error("Request Interceptor Error:", error);
  return Promise.reject(error);
});

API.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response && error.response.status === 401) {
      console.log("***********Unauthorized Error**********");
      await refreshAuthToken();
    }
    return Promise.reject(error);
  }
);



export default API;
